<template>
	<div class="m-channel-banner" :style="{'height': height}">
		<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == currentBanner}">
			<a>
				<sub-image class="image" :src="item.img_url" mode="aspectFill" :style="{'height': height}"></sub-image>
			</a>
		</div>
		
		<div v-if="unitData.list && unitData.list.length > 1" class="nav">
			<div v-for="(item, i) in unitData.list" :key="i" class="item" :class="{'z-crt': i == currentBanner}"></div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {},
				currentBanner: 0
			}
		},
		
		computed: {
			height() {
				if (this.unitData.list && this.unitData.list[0]) {
					return this.unitData.list[0].img_height + 'px';
				}
				return '400px';
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-channel-banner {
		position: relative;
		overflow: hidden;
		
		> .item {
			position: absolute;
			left: 0;
			right: 0;
			top: 0;
			text-align: center;
			opacity: 0;
			transition: opacity .3s ease;
			
			&.z-crt {
				z-index: 1;
				opacity: 1;
			}
			
			.image {
				position: relative;
				left: 50%;
				min-width: 2400px;
				transform: translate(-50%,0);
			}
		}
		
		.nav {
			z-index: 1;
			position: absolute;
			left: 50%;
			bottom: 14px;
			font-size: 0;
			transform: translate(-50%,0);
			
			.item {
				display: inline-block;
				width: 9px;
				height: 9px;
				border-radius: 100%;
				margin: 0 5px;
				background: #fff;
				opacity: .9;
				transition: all .3s ease;
				cursor: pointer;
				
				&.z-crt {
					opacity: 1;
					transform: scale(1.333);
				}
			}
		}
	}
</style>
